import { gql } from '@apollo/client';

const schema = {
  get: {
    name: "companyType",
    serviceName: "shared",
    query: gql`
      query companyType($ids: [String]) {
        companyType(ids: $ids) {
          data {
            id
            title
          }
        }
      }
    `,
  },
};

export default schema;
